import {Button} from "antd";
import React from "react";
import CountDown from "../../../components/CountDown/CountDown";
import styles from "./OtpPage.module.css";
import MultiInput from "../../../components/MultiInput/MultiInput";

export const OtpPage = (props) => {
    const {loginOtp, otpCode, setOtpCode, setOtp, setPhoneNumber, getCaptchaImage} = props
    return (
        <div className={`form ${styles.OtpForm}`}>
            <MultiInput
                className="mar-b-50"
                data={otpCode}
                dataHandler={(e) => setOtpCode(e)}
                length={6}
                maxLength={1}
            />
            <div className={styles.CountdownWrapper}>
                <CountDown
                    className={styles.OtpPageCounter}
                    time={90000}
                    onTimeUp={() => {
                        setOtp(false)
                    }}
                />
                <span>  تا انقضای کد‌ تایید</span>
            </div>
            <button className={styles.EditPhoneNumber} onClick={() => {
                setOtp(false);
                setPhoneNumber("");
                getCaptchaImage()
            }}>
                اصلاح شماره موبایل
            </button>
            <Button
                className="button-promotion mt-20 w-100"
                onClick={() => loginOtp()}>
                تایید
            </Button>
        </div>
    )
}